import { render, staticRenderFns } from "./SectionNews.vue?vue&type=template&id=8b4b61f8&scoped=true"
import script from "./SectionNews.vue?vue&type=script&lang=js"
export * from "./SectionNews.vue?vue&type=script&lang=js"
import style0 from "./SectionNews.vue?vue&type=style&index=0&id=8b4b61f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4b61f8",
  null
  
)

export default component.exports